import React from 'react'

const JS_Essentials_Coding_Pratice_7 = () => {
  return (
    <div>
      <h1>Coding Practice 7</h1>
    </div>
  )
}

export default JS_Essentials_Coding_Pratice_7
